import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { riseItem } from "./Reveal";

// Product-family card with spotlight + clipped photography.
export default function FruitCard({ fruit, index }) {
  return (
    <motion.div variants={riseItem}>
      <Link
        to={`/calendar?fruit=${fruit.slug}`}
        data-testid={`fruit-card-${fruit.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-sm border border-border bg-cream-200 transition-colors duration-500 hover:border-forest/40"
      >
        <div className="relative flex h-52 items-center justify-center overflow-hidden bg-white">
          <span className="absolute left-4 top-4 z-10 font-mono text-xs text-forest-muted">
            {String(index + 1).padStart(2, "0")}
          </span>
          <img
            src={fruit.image}
            alt={fruit.name}
            loading="lazy"
            className="relative z-10 max-h-40 w-auto object-contain transition-transform duration-1000 ease-out group-hover:scale-[1.09] group-hover:-rotate-2"
          />
        </div>

        <div className="flex flex-1 flex-col border-t border-border p-5">
          <div className="mb-1 flex items-center justify-between">
            <h3 className="font-display text-3xl font-semibold text-forest">{fruit.name}</h3>
            <ArrowUpRight className="h-5 w-5 text-forest-muted transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-gold" />
          </div>
          <div className="mb-3 flex items-center gap-3 font-mono text-xs text-forest-light">
            <span>{fruit.variety_count} varieties</span>
            <span className="text-border">·</span>
            <span>{fruit.months_supply_count}/12 mo in supply</span>
          </div>
          <p className="text-sm leading-relaxed text-forest-light">{fruit.description}</p>

          <div className="mt-4 flex items-center gap-4 pt-3 font-mono text-[0.68rem] uppercase tracking-wider">
            <span className="flex items-center gap-1.5 text-harvest">
              <span className="h-2 w-2 rounded-full bg-harvest" />
              {fruit.indian_count} Indian
            </span>
            <span className="flex items-center gap-1.5 text-terracotta">
              <span className="h-2 w-2 rounded-full bg-terracotta" />
              {fruit.imported_count} Import
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
